import { useMutation, useQueryClient } from "react-query";
import { edit, editExperiment } from "./logic";

export function useSampleEdit(id) {
  const queryClient = useQueryClient();
  return useMutation(edit, {
    onSuccess: () => {
      queryClient.invalidateQueries(["sample", id]);
      queryClient.invalidateQueries("recentSamples");
    },
    onError: (error) => {
      console.error("Error: ", error);
    },
  });
}
export function useExperimentEdit(id) {
  const queryClient = useQueryClient();
  return useMutation(editExperiment, {
    onSuccess: () => {
      queryClient.invalidateQueries(["sample", id]);
      queryClient.invalidateQueries("recentSamples");
    },
    onError: (error) => {
      console.error("Error: ", error);
    },
  });
}
